
 import { authenticatedFetch } from "../Auth/Auth";
 import { getCurrentConfig } from '../../config/config';
 
 const config = getCurrentConfig();

export const addListing = async (addListingJSONbody) => {
   
 
    const response = await authenticatedFetch(`${config.API_BASE_URL}/listings`, {
        method: 'POST',
        headers: {
        
          'Content-Type': 'application/json',
          'User-Agent': 'agentApp/1.0',
        },
        body: JSON.stringify(addListingJSONbody)
      });
      
      if (response.ok) {
        const responseData = await response.json();
        return responseData;
      } else {
        throw new Error(`Error adding listing`);
      }




};